export const isSetValueCurveAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'setValueCurve';
};
//# sourceMappingURL=set-value-curve-automation-event.js.map